/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

export const uploadGenerationPecoto = (annee, trimestre) =>
  `${baseUrlApi}/pecotos/${annee}/${trimestre}`;
export const getDownloadPecoto = (id) => `${baseUrlApi}/pecotos/${id}/download`;
